import { render } from "./IngresoPreguntas.vue?vue&type=template&id=14602244&scoped=true"
import script from "./IngresoPreguntas.vue?vue&type=script&lang=js"
export * from "./IngresoPreguntas.vue?vue&type=script&lang=js"

import "./IngresoPreguntas.vue?vue&type=style&index=0&id=14602244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14602244"]])

export default __exports__